import { SupplierCompanyTradingPartnerApprovalStatus } from '../../../types';

// from old packages\common\src\services\Company\Api
export enum InvoiceProfileType {
    Normal = 0,
    ScanKey = 1,
}

export interface TradingPartnerSearchViewModel {
    VendorClass: string;
    CompanyID: number | null;
    BuyerCompanyID: number;
    Name: string | null;
    ContactName: string;
    ContactEmail: string;
    VendorNumber: string;
    ProcessingMode?: number;
    VendorId: number | null;
    VendorSiteNumber: string | null;
    InvoiceProfileType: InvoiceProfileType | null;
    OrgUnit: string | null;
    // comma separated list of user ids
    UserIds: string | null;
    // comma separated list of user group ids
    UserGroupIds: string | null;
    ApprovalStatus: SupplierCompanyTradingPartnerApprovalStatus | null;
}
